import { faClock, faComment, faMapMarkerAlt, faUserGroup, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { formatDate } from 'helpers/formatDate';
import { entryStatuses } from 'constants/entryStatuses';
import { PaymentsCell } from 'pages/Schedule/PaymentsCell';
import { PersonCell } from 'pages/Schedule/PersonCell';
import { Actions } from './Actions';
import styles from './GroupEntries.scss';

export const GroupEntries = ({ entries }) => {
  const formatTime = (time) => time.slice(0, 5);

  const getStatus = (status) => entryStatuses.find(({ key }) => key === status);

  const isGroupBooking = (booking) => booking.group !== null;

  return (
    <div className={styles.table}>
      <div className={cn(styles.tableRow, styles.tableRowHeader)}>
        <div className={styles.tableCell}>Послуга</div>
        <div className={styles.tableCell}>Дата та час</div>
        <div className={styles.tableCell}>Зала</div>
        <div className={styles.tableCell}>Тренери</div>
        <div className={styles.tableCell}>Оплата</div>
        <div className={cn(styles.tableCell, styles.tableCellStatus)}>Статус</div>
      </div>

      {entries.map((booking) => (
        <div className={styles.tableRow} key={booking.id}>
          <div className={cn(styles.tableCell, styles.service)}>
            <FontAwesomeIcon icon={isGroupBooking(booking) ? faUsers : faUserGroup} className={styles.icon} />
            <div className={styles.info}>
              <span className={styles.name}>{booking.service}</span>
              {booking.comment && (
                <div className={styles.comment}>
                  <FontAwesomeIcon icon={faComment} />"{booking.comment}"
                </div>
              )}
            </div>
          </div>

          <div className={cn(styles.tableCell, styles.time)}>
            <FontAwesomeIcon icon={faClock} />
            <div>
              <span className={styles.date}>{formatDate(booking.date, 'UA', true)}</span>
              <span>
                {formatTime(booking.startTime)} {booking.endTime && `- ${formatTime(booking.endTime)}`}
              </span>
            </div>
          </div>

          <div className={cn(styles.tableCell, styles.location)}>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <span className={styles.hallName}>{booking.hallName}</span>
          </div>

          <PersonCell booking={booking} people={booking.coaches} isGroup={isGroupBooking(booking)} role='coach' />

          <PaymentsCell booking={booking} />

          <div className={cn(styles.tableCell, styles.tableCellStatus)}>
            <div className={cn(styles.status, styles[getStatus(booking.status).key])}>
              <FontAwesomeIcon icon={getStatus(booking.status).icon} />
              {getStatus(booking.status).name}
            </div>
          </div>

          <Actions className={styles.actions} entry={booking} />
        </div>
      ))}
    </div>
  );
};
